<ion-header class="ion-no-border ion-header-modal-desktop">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        data-cy="close-issue-details-modal-button"
        (click)="dismissModal(true)"
      >
        <ion-icon
          slot="icon-only"
          name="close-outline"
          data-cy="issue-details-modal-icon"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="select-issue-label">
      {{ 'i18n.requestCredit.selectIssue' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="serviceRequestService?.issues$ | async as issues"
  class="ion-content-modal-desktop"
>
  <div
    *ngIf="!issues?.length"
    class="no-data-found"
    data-cy="no-issues-found-message-text"
  >
    <p>{{ 'i18n.requestCredit.noIssuesFound' | translate }}</p>
  </div>
  <ion-grid *ngIf="issues?.length">
    <ion-row>
      <!-- Issue Options -->
      <ion-col size="5.75">
        <ion-list class="issues-list">
          <ion-item-divider></ion-item-divider>
          <ion-item
            *ngFor="let issue of issues; let i = index"
            id="issue-number-{{ i }}"
            [class.selected]="
              serviceRequestService?.modalRelatedParams?.issue === issue
            "
            detail="true"
            (click)="getIssueDetails(issue)"
            data-cy="click-get-issue-details-item"
          >
            <ion-label>
              <p class="info-top" data-cy="issue-display-text">
                {{ issue?.displayText }}
              </p>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>

      <!-- Issue Details Options -->
      <ng-container *ngIf="serviceRequestService?.issueDetails">
        <ion-col class="options" offset="0.5" size="5.75">
          <div class="options-title">
            <ion-label data-cy="select-issue-details-label">
              {{ 'i18n.requestCredit.selectIssueDetails' | translate }}
            </ion-label>
          </div>
          <div
            *ngIf="!serviceRequestService?.issueDetails?.length"
            class="no-data-found"
            data-cy="no-issues-found-message-text"
          >
            <p>
              {{ 'i18n.requestCredit.noIssuesDetailsFound' | translate }}
            </p>
          </div>
          <ion-list
            *ngIf="serviceRequestService?.issueDetails?.length"
            class="issue-details-list"
          >
            <ion-item-divider></ion-item-divider>
            <ion-radio-group
              class="radio-options"
              [(ngModel)]="
                serviceRequestService.modalRelatedParams.issueDetailsText
              "
            >
              <ion-item
                *ngFor="let detail of serviceRequestService?.issueDetails"
                (click)="onSelectIssueDetails(detail)"
                data-cy="click-select-issue-detail-item"
              >
                <div class="radio-option-text">
                  <ion-label data-cy="detail-display-label">
                    {{ detail?.displayText }}
                  </ion-label>
                </div>
                <ion-radio
                  mode="md"
                  slot="end"
                  value="{{ detail?.displayText }}"
                  data-cy="detail-display-radio"
                ></ion-radio>
              </ion-item>
            </ion-radio-group>
          </ion-list>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-footer-modal ion-footer-modal-desktop">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="cancel-modal-btn"
        data-cy="cancel-issue-detail-modal-button"
        class="usf-outline-green-dsktp-tblt-modal-button"
        (click)="dismissModal(true)"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        id="select-modal-btn"
        class="select-modal-btn"
        data-cy="select-issue-detail-modal-button"
        [ngClass]="
          !serviceRequestService?.modalRelatedParams?.issueDetails
            ? 'usf-fill-disabled-dsktp-tblt-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal(false)"
      >
        {{ 'i18n.requestCredit.select' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
